if (!customElements.get('advanced-product-recommendations')) {
  class AdvancedProductRecommendations extends HTMLElement {
    constructor () {
      super();
      this.section = this.closest('.shopify-section');
      this.section.style.display = 'none';
    }

    connectedCallback () {
      fetch(this.dataset.url).then((response) => response.text()).then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('advanced-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.section.style.display = 'block';
        } else {
          this.section.style.display = 'none';
        }
      }).catch((e) => {
        console.error(e);
      });
    }
  }

  customElements.define('advanced-product-recommendations', AdvancedProductRecommendations);
}